import React from 'react';
import styles from './SkeletonLoader.module.scss';

const SkeletonLoader = () => {
    return (
        <div className={styles.skeletonContainer}>
            <div className={styles.skeletonWidgets}>
                {[...Array(4)].map((_, i) => (
                    <div key={i} className={styles.skeletonWidget}></div>
                ))}
            </div>
            <div className={styles.skeletonHeader}></div>
            <div className={styles.skeletonTable}>
                {[...Array(5)].map((_, i) => (
                    <div key={i} className={styles.skeletonRow}></div>
                ))}
            </div>
        </div>
    );
};

export default SkeletonLoader;